import { Stack, Typography } from '@mui/material'

export const Footer = () => {
  return (
    <Stack
      direction='row'
      justifyContent='center'
      sx={{ backgroundColor: '#ffffff', py: '9px' }}
    >
      <Typography fontSize={12} color='#111111' sx={{ opacity: '60%' }}>
        &copy; All Rights Reserved, Osaka Digital Exchange Co.,Ltd.
      </Typography>
    </Stack>
  )
}
